module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/recuperar-pyme/recuperar-pyme.component.css
// module id = ./src/app/components/recuperar-pyme/recuperar-pyme.component.css
// module chunks = main